import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import Dashboard from '@/views/Dashboard'
import Login from '@/views/Login'
import ProductView from '@/views/ProductView'
import Analytics from '@/views/Analytics'
import Alerts from '@/views/Alerts'
import AvailabilityMapping from '@/views/AvailabilityMapping'
import ReportsSettings from '@/views/ReportsSettings'
import Users from '@/views/Users'
import ProfileSettingsAuth from '@/views/ProfileSettingsAuth'
import ProfileSettingsConsole from '@/views/ProfileSettingsConsole'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { layout: 'default' }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/product-view',
      name: 'ProductView',
      component: ProductView
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics
    },
    {
      path: '/alerts',
      name: 'Alerts',
      component: Alerts
    },
    {
      path: '/availability-mapping',
      name: 'AvailabilityMapping',
      component: AvailabilityMapping
    },
    {
      path: '/reports-settings',
      name: 'ReportsSettings',
      component: ReportsSettings
    },
    {
      path: '/users',
      name: 'Users',
      component: Users
    },
    {
      path: '/profile-change-auth',
      name: 'ProfileSettingsAuth',
      component: ProfileSettingsAuth,
      meta: { layout: 'authSettings' }
    },
    {
      path: '/profile-settings-scheme',
      name: 'ProfileSettingsConsole',
      component: ProfileSettingsConsole,
      meta: { layout: 'authSettings' }
    },
    {
      path: '*',
      component: Dashboard
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!store.state.auth.authtoken && to.path !== '/login') {
    next('/login')
  } else if (store.state.auth.authtoken && to.path === '/login') {
    next('/dashboard')
  } else {
    next()
  }
  store.dispatch('sidebar/closeSidebar')
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js